// HOOKS
import { useMutation } from "@apollo/client";
import { useParams, useNavigate } from "react-router-dom";
// GRAPHQL
import { USER_UNAUTHENTICATED_PASSWORD_RESET } from "../../graphql/mutations/users/users.mutations";

const useUnauthenticatedPasswordReset = () => {
  const navigate = useNavigate();
  const { token, email } = useParams();
  const [resetPasswordMutation] = useMutation(
    USER_UNAUTHENTICATED_PASSWORD_RESET
  );

  const navigateToLogin = () => {
    navigate("/login");
  };
  const encodedEmail = decodeURIComponent(email);
  const resetPassword = async (password) => {
    try {
      const res = await resetPasswordMutation({
        variables: { token, password, email: encodedEmail },
      });
      // If the password reset is successful, alert the user
      if (res?.data?.userUnauthenticatedPasswordReset)
        alert(res.data.userUnauthenticatedPasswordReset);
      // Redirect the user to the login page
      navigateToLogin();
    } catch (error) {
      alert("Failed to reset password.");
    }
  };

  return { resetPassword };
};

export default useUnauthenticatedPasswordReset;
